



import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import DashboardHeader from "../components/Headers/DashboardHeader";
import { Box, useMediaQuery, Drawer } from "@mui/material";
import { decryptToken } from "../Utlis/Encryption";
import { BASE_URL } from "../components/BaseUrl";
import { useSelector } from "react-redux";
import GlobalBannerAlert from "../components/GlobalPaymentAlert";
import { useNavigate, useLocation } from "react-router-dom";
import UpgradePromptModal from "../components/UpgradeWarningModal";
import { useGlobalUnreadCount } from "../hooks/useGlobalUnreadCount";
import { isPathRestrictedForPlan } from "../utils/planMenuAccess";
import {
  getSubscriptionBannerState,
  isSubscriptionAccessBlocked,
  SUBSCRIPTION_PLANS_PATH,
} from "../utils/subscriptionBanner";
import { useTranslation } from "react-i18next";

const HEADER_HEIGHT = 64;
const SIDEBAR_WIDTH = 210;

const DashboardLayout = () => {
  const [openSidebar, setOpenSidebar] = useState(false);
  const [openHeaderMenu, setOpenHeaderMenu] = useState(false);
  const isMobile = useMediaQuery("(max-width:768px)");
  const token = useSelector((state) => state.auth.token);
  const trialInfo = useSelector((state) => state.auth.trialInfo);
  const decryptedToken = token ? decryptToken(token) : null;
  const [profile, setProfile] = useState(null);
  const [planAlert, setPlanAlert] = useState(null);
  const [planId, setPlanId] = useState(null);
  const [detailedStatus, setDetailedStatus] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const subscriptionAccessBlocked = isSubscriptionAccessBlocked(detailedStatus);

  useGlobalUnreadCount();

  // Fetch Profile
  useEffect(() => {
    const fetchProfile = async () => {
      if (!decryptedToken) return;
      try {
        const res = await fetch(`${BASE_URL}/company-admins/profile`, {
          headers: { Authorization: `Bearer ${decryptedToken}` },
        });
        const json = await res.json();
        if (!res.ok || json.error)
          throw new Error(json.message || "Failed to load profile");
        setProfile(json.data);
      } catch (err) {
        console.error("Profile fetch error:", err);
      }
    };
    fetchProfile();
  }, [decryptedToken]);

  // Fetch Plan + log everything
  useEffect(() => {
    const fetchPlan = async () => {
      if (!decryptedToken) {
        console.warn("No decrypted token found — skipping plan fetch");
        return;
      }

      console.log("Fetching plan details...");
      try {
        const res = await fetch(`${BASE_URL}/payments/company-admin/plan-details`, {
          headers: { Authorization: `Bearer ${decryptedToken}` },
        });

        if (!res.ok) throw new Error("HTTP error " + res.status);

        const json = await res.json();
        console.log("Plan details response:", json);

        setPlanId(json?.data?.current_plan?.plan_id || null);
        setDetailedStatus(json?.data?.subscription_status?.detailed_status ?? null);

        const bannerState = getSubscriptionBannerState(json?.data);
        console.log("Detailed Status:", json?.data?.subscription_status?.detailed_status);
        console.log("Alerts:", json?.data?.alerts);
        console.log("Banner state:", bannerState);

        if (bannerState.showBanner) {
          setPlanAlert({
            detailedStatus: bannerState.detailedStatus,
            alert: bannerState.alert,
            cta: bannerState.cta,
            daysRemaining: bannerState.daysRemaining,
          });
        } else {
          setPlanAlert(null);
        }
      } catch (err) {
        console.error("Error fetching plan alert:", err);
      }
    };

    fetchPlan();
  }, [decryptedToken]);

  // TEMPORARY TEST (force banner on for debugging)
  // Remove after testing:
  // useEffect(() => {
  //   setPlanAlert({ detailedStatus: "warning", message: "Test Banner — Works!" });
  // }, []);
const [showUpgradeModal, setShowUpgradeModal] = useState(false);
const outletContainerRef = React.useRef(null);

  useEffect(() => {
    if (subscriptionAccessBlocked) {
      setShowUpgradeModal(location.pathname !== SUBSCRIPTION_PLANS_PATH);
      return;
    }

    const effectivePlanId = planId ?? trialInfo?.current_plan?.plan_id ?? null;
    if (!effectivePlanId) {
      setShowUpgradeModal(false);
      return;
    }

    setShowUpgradeModal(isPathRestrictedForPlan(effectivePlanId, location.pathname));
  }, [
    location.pathname,
    planId,
    trialInfo?.current_plan?.plan_id,
    subscriptionAccessBlocked,
  ]);

  return (
  <>
  {/* Global Banner */}
  {planAlert && (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 2000,
      }}
    >
      <GlobalBannerAlert
        detailedStatus={planAlert.detailedStatus}
        alert={planAlert.alert}
        cta={planAlert.cta}
        daysRemaining={planAlert.daysRemaining}
      />
    </Box>
  )}

  {/* Main Layout Grid */}
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : `${SIDEBAR_WIDTH}px 1fr`,
      gridTemplateRows: `${HEADER_HEIGHT}px 1fr`,
      height: "100vh",
      width: "100vw",
      overflow: "hidden",
      pt: planAlert ? "48px" : "0px", // ✅ this ensures the WHOLE grid moves down
      transition: "padding-top 0.3s ease",
    }}
  >
    {/* Sidebar */}
    {!isMobile && (
      <Box
        sx={{
          gridRow: "1 / span 2",
          gridColumn: "1 / 2",
          borderRight: "1px solid #ddd",
          backgroundColor: "#fff",
          zIndex: 1200,
        }}
      >
        <Sidebar  onClose={() => setOpenSidebar(false)} bannerOffset={planAlert ? 52 : 0} 
onShowUpgradeModal={(state) => setShowUpgradeModal(state)} // can open or close
  isUpgradeModalOpen={showUpgradeModal}
  subscriptionAccessBlocked={subscriptionAccessBlocked}

      //  outletContainerRef={outletContainerRef}
       />
      </Box>
    )}

    {/* Drawer for mobile */}
    {isMobile && (
      <Drawer
        anchor="left"
        open={openSidebar}
        onClose={() => setOpenSidebar(false)}
      >
        
        <Sidebar mobile onClose={() => setOpenSidebar(false)} bannerOffset={planAlert ? 52 : 0} 
         
       onShowUpgradeModal={(state) => setShowUpgradeModal(state)} // can open or close
  isUpgradeModalOpen={showUpgradeModal}
  subscriptionAccessBlocked={subscriptionAccessBlocked}

      //  outletContainerRef={outletContainerRef}
       />
        
      </Drawer>
    )}

    {/* Header */}
    <Box
     
      sx={{
        gridColumn: isMobile ? "1 / 2" : "2 / 3",
        gridRow: "1 / 2",
        position: "fixed",
        top: planAlert ? 52 : 0,
        left: isMobile ? 0 : SIDEBAR_WIDTH,
        width: isMobile ? "100%" : `calc(100% - ${SIDEBAR_WIDTH}px)`,
        ml: isMobile ? 0 : 1,
        zIndex: 1100,
        backgroundColor: "#fff",
        borderBottom: "1px solid #ddd",
        transition: "top 0.3s ease",
         
      }}
    >
      <DashboardHeader
        isMobile={isMobile}
        toggleSidebar={() => setOpenSidebar(true)}
        toggleHeaderMenu={() => setOpenHeaderMenu(!openHeaderMenu)}
        showHeaderMenu={openHeaderMenu}
        profile={profile}
      />
    </Box>

    {/* Main Outlet Area */}
    <Box
    ref={outletContainerRef}
  // id="outlet-blur-container"
      sx={{
         position: "relative",
        gridColumn: isMobile ? "1 / 2" : "2 / 3",
        gridRow: "2 / 3",
        overflowY: "auto",
        backgroundColor: "#F9FAFB",
        px: isMobile ? 0.5 : 1.5,
        py: 2,
        ml: isMobile ? 0 : 1.5,
       
      }}
    >
      <Outlet context={{ updateProfile: setProfile }} />
        <UpgradePromptModal
    open={showUpgradeModal}
    onClose={subscriptionAccessBlocked ? undefined : () => setShowUpgradeModal(false)}
    onConfirm={() => {
      setShowUpgradeModal(false);
      navigate(SUBSCRIPTION_PLANS_PATH);
    }}
    message={
      subscriptionAccessBlocked
        ? t("subscriptionPage.banner_subscription_cancelled")
        : undefined
    }
    confirmLabel={
      subscriptionAccessBlocked ? t("subscriptionPage.subscribe_now") : undefined
    }
  containerRef={outletContainerRef}  // <- key line to scope blur to Outlet
  />
    </Box>
  </Box>
</>
  );
};

export default DashboardLayout;





 

